import { render } from "./ButtonBack.vue?vue&type=template&id=79066780&scoped=true"
const script = {}

import "./ButtonBack.vue?vue&type=style&index=0&id=79066780&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79066780"]])

export default __exports__